import { render, staticRenderFns } from "./BrandsProducts.vue?vue&type=template&id=1170162c&scoped=true&"
import script from "./BrandsProducts.vue?vue&type=script&lang=js&"
export * from "./BrandsProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1170162c",
  null
  
)

export default component.exports